import type { DispersionsTranslations } from "../interfaces/dispersions";

export const dispersionsTranslations: DispersionsTranslations = {
  header_title: "Send money",
  header_subtitle: "Instantly and directly to whoever receives it",
  header_chip: "New transfer",
  step_1_title: "Currency Conversion",
  step_2_title: "Recipient Information",
  step_3_title: "Confirmation",
  stepper_amount: "Amount",
  stepper_recipient: "Recipient",
  stepper_review: "Review",

  balance_label: "Available Balance",

  origin_currency_label: "Origin Currency",
  destination_currency_label: "Destination Currency",
  select_origin_currency: "Select origin currency",
  select_destination_currency: "Select destination currency",
  origin_country_label: "Origin Country",
  destination_country_label: "Destination Country",
  amount_origin_label: "Amount to Send",
  amount_destination_label: "Amount to Receive",
  conversion_rate_label: "Conversion Rate",
  amount_to_send: "Amount to Send",
  amount_to_receive: "Amount to Receive",
  fees_label: "Fee",
  total_deducted_label: "Total Deducted",

  fields: {
    phone_number: "Phone Number",
    key_number: "Key Number",
    pix_type: "PIX Key Type",
    pix_key: "PIX Key",
    description: "Description",
    clabe: "CLABE",
    recipient: "Recipient",
    protocol: "Protocol",
    first_name: "First Name",
    last_name: "Last Name",
    identification_type: "Identification Type",
    identification_number: "Identification Number",
    bank: "Bank",
    account_type: "Account Type",
    account_number: "Account Number",
    address: "Address",
    city: "City",
    state: "State/Province",
    postal_code: "Postal Code",
    birth_date: "Birth Date",
    email: "Email",
    gender: "Gender",
    webhook_url: "Webhook URL",
    full_name: "Full Name",
    document_type: "Document Type",
    document_number: "Document Number",
    network: "Network",
    wallet: "Wallet",
  },

  placeholders: {
    phone_number: "e.g. 3001234567",
    key_number: "e.g. 3113113113",
    pix_key: "Enter your PIX key",
    description: "Enter a description (optional)",
    clabe_mexico: "646180110400000007",
    recipient: "John Doe",
    account_number: "Enter account number",
    email: "email@example.com",
    first_name: "John",
    last_name: "Doe",
    identification_type: "RUT",
    identification_number: "12345678-9",
    address: "Main Ave 123",
    city: "Santiago",
    state: "Metropolitan",
    postal_code: "7500000",
    full_name: "John Doe Smith",
    document_number: "1234567890",
    wallet: "0x742d35Cc6634C0532925a3b844Bc9e7595f0bEb",
    webhook_url: "https://api.example.com/webhook/dispersion",
  },

  helpers: {
    phone_number_colombia: "Must be a 10-digit number",
    key_number_colombia: "Must be a 10-digit key number",
    pix_key_cpf: "Enter 11 digits of CPF without formatting",
    pix_key_cnpj: "Enter 14 digits of CNPJ without formatting",
    pix_key_email: "Enter a valid email in lowercase",
    pix_key_phone: "Enter 9 digits of phone number",
    pix_key_evp: "Enter UUID in valid format",
    clabe_18_digits: "Must contain exactly 18 digits",
    webhook_url: "URL to receive notifications (maximum 255 characters)",
    document_number_ecuador: "CEDULA: 10 digits, RUC: 13 digits, PASSPORT: 6-9 characters",
    identification_number_panama: "CIP: 8 digits, PASSPORT: 9 alphanumeric characters",
    wallet_address: "Destination wallet address",
  },

  button_next: "Next",
  button_previous: "Previous",
  button_confirm: "Confirm",
  button_cancel: "Cancel",
  button_retry: "Retry",
  button_continue: "Continue",
  button_authorize: "Authorize transfer",

  twofa_modal_title: "Two-factor verification",
  twofa_modal_instruction: "Enter the 6-digit code from your authenticator app to confirm this transfer.",
  twofa_verifying: "Verifying...",

  recipient_client_label: "Client",
  recipient_client_loading: "Loading clients…",
  recipient_client_placeholder: "Search client by name...",
  recipient_account_label: "Client account",
  recipient_account_loading: "Loading accounts…",
  recipient_account_placeholder: "Select an account...",
  recipient_account_fallback_name: "Account",
  recipient_pix_type_label: "PIX key type",
  recipient_pix_type_placeholder: "Select a key type...",
  recipient_description_label: "Description",
  recipient_description_placeholder: "Transfer description",
  footer_rate_note: "Amounts are locked at this quote's rate until it expires.",

  error_create_failed: "We couldn't create the transfer",
  error_client_required: "Select a client",
  error_client_account_required: "Select a client account",
  error_description_required: "Description is required",
  error_pix_key_invalid: "Enter a valid PIX key",
  error_recipient_name_required: "Enter the recipient's name",
  error_clabe_invalid: "Enter a valid 18-digit CLABE",
  error_cbu_cvu_invalid: "Enter a valid 22-digit CBU/CVU",
  error_cuit_invalid: "The CUIT/CUIL must be 11 digits",
  error_breb_key_invalid: "Enter a valid Bre-B key",
  error_no_organization: "Your user has no organization associated to create the transfer.",
  error_payment_rejected:
    "The payment was rejected by the destination bank. Check the recipient details and try again.",
  error_origin_required: "Select the source currency",
  error_destination_required: "Select the destination currency",
  error_amount_required: "Enter an amount",
  error_amount_positive: "The amount must be greater than 0",
  loading_quote: "Getting quote...",
  loading_balance: "Loading balance...",

  confirmation_review_title: "Review Details",
  confirmation_amount_section: "Amount Information",
  confirmation_recipient_section: "Recipient Information",

  step_conversion_title: "Conversion",
  step_recipient_title: "Recipient",
  step_confirmation_title: "Confirmation",

  quote_valid_for: "This rate is valid for",
  quote_expiring_soon: "Quote will expire soon",
  quote_expired_message: "The quote has expired",
  quote_expired_modal_title: "Quote Expired",
  quote_expired_modal_message:
    "The exchange rate has expired. To continue with your transfer, you need to recalculate the quote with current rates.",
  quote_expired_modal_hint: "You can also start over if you want to change amounts or destinations.",
  quote_expired_recalculate: "Recalculate Quote",
  quote_expired_start_over: "Start Over",

  register_client_button: "Register client",
  client_kyc_blocked_note:
    "The selected client has not completed identity verification (KYC) yet. You cannot continue with this transfer until they are verified.",
  client_kyc_unavailable_note:
    "We could not verify your clients' identity (KYC) status. For security, the transfer cannot continue until the verification completes.",
  client_kyc_retry_button: "Retry verification",
  register_account_button: "Register account",
  client_not_verified_badge: "Not verified",
  recipient_use_client_label: "Send to a registered client",
  recipient_manual_hint: "Type in the recipient's details. You don't need to have them registered.",
  recipient_use_client_hint: "Pick a client and we'll fill in their payout details.",
  step1_no_wallets_note: "You have no active wallets. Activate one in Wallets to start sending.",
  step1_origin_wallet_frozen_badge: "Frozen",
  step1_cross_currency_hint:
    "We convert {{origin}} to {{destination}} on confirmation; the rate is locked in this quote.",
  step1_same_currency_hint: "You send and the recipient receives in {{currency}} — no conversion.",
  runtime_wallet_missing: "You don't have a {{currency}} wallet. Activate it in Wallets.",
  quote_breakdown_title: "Quote breakdown",
  quote_conversion_fee_label: "Conversion fee",
  quote_converted_amount_label: "Converted amount",
  quote_dispersion_fee_label: "Transfer fee",
  quote_recalculated_note: "Amounts were updated with the current rate. Review them before authorizing.",
  error_quote_required: "A valid quote is required to authorize the transfer.",
  error_quote_expired: "The quote expired. Recalculate it to continue.",
  error_quote_pricing: "We are updating the quote. Give it a moment.",
  error_quote_already_used: "This quote was already used. Check your history before retrying.",
  error_payout_unconfirmed:
    "We could not confirm the state of this operation. Check your history before retrying.",
  result_error_check_activity: "View activity history",
  error_verification_required:
    "Your account is not verified yet. Complete the verification to be able to send money.",
  result_error_go_verify: "Go to verification",
  error_quote_invalid: "We couldn't use this quote. Recalculate it and try again.",
  error_unsupported_corridor: "This corridor isn't available for transfers.",
  runtime_wallet_frozen_warning: "Your {{currency}} wallet is frozen: you can't send money right now.",
  runtime_insufficient_funds: "Insufficient balance in your {{currency}} wallet. You can send up to {{max}}.",
  runtime_balance_error: "We couldn't load your {{currency}} wallet balance.",

  result_processing_title: "Sending your money…",
  result_processing_subtitle: "We are making the transfer. This takes a few seconds.",
  result_status_created: "Pending dispatch",
  result_status_paid: "Delivered",
  result_status_processing: "Processing at the bank",
  result_status_failed: "Rejected",
  result_status_cancelled: "Cancelled",
  result_status_reversed: "Returned",
  result_success_title: "Money sent",
  result_pending_title: "Transfer on its way",
  result_rejected_title: "The transfer did not go through",
  result_receipt_to: "to",
  result_success_sent_note: "The money is already in their account.",
  result_success_created_note: "It is registered and goes out shortly.",
  result_pending_sent_note: "The destination bank has yet to confirm it.",
  result_rejected_note: "The money is back in your wallet.",
  result_rejected_note_converted:
    "The money is available in your {{currency}} wallet, not the one you sent from: the conversion had already happened and is not reversed. The conversion fee is not refunded.",
  result_pending_live_hint: "This screen updates on its own as soon as the bank confirms the transfer.",
  result_reference_label: "Reference",
  result_reference_copy: "Copy the reference",
  result_reference_copied: "Reference copied",
  route_label: "Route",
  send_label: "You send",
  concept_label: "Concept",
  result_show_details: "View details",
  result_hide_details: "Hide details",
  receipt_save_recipient: "Save this recipient",
  receipt_save_recipient_done: "Saved. Next time you can pick them from your client list.",
  receipt_save_recipient_partial:
    "We created the client, but their account was not saved. You can add it from Clients.",
  result_send_again: "Send again",
  result_send_again_pending_hint:
    "Available once the transfer resolves. Repeating it now would be a second payment to the same recipient.",
  result_send_to_someone_else: "Send to someone else",
  result_back_to_wallets: "Back to my wallets",
  result_error_title: "We could not send the money",
  result_error_fallback: "Check the recipient details or try again in a few minutes.",
  result_error_adjust: "Adjust details",

  quote_rate_valid_for: "Rate valid for",
  quote_receives_label: "Receives:",
  quote_exchange_rate_label: "Exchange rate",
  quote_total_debit_label: "Total to debit from your account",
  quote_recipient_receives_label: "The recipient receives",

  rail_label: "Rail",
  rail_transfer: "Transfer",
  rail_crypto: "Crypto",

  step1_origin_label: "You send from",
  step1_destination_label: "The recipient receives in",
  step1_select_placeholder: "Select…",
  step1_origin_account_title: "Source account",
  step1_available_balance: "Available balance",
  step1_refresh_balance: "Refresh balance",
  step1_amount_placeholder: "0.00",
  step1_amounts_hint: "Edit either one — the other is calculated with the rate.",
  step1_quote_loading: "Calculating rate…",
  step1_quote_error: "We could not get the rate.",
  error_amount_above_max: "The amount exceeds this corridor's maximum of {{limit}}.",
  error_amount_below_min: "The amount is below this corridor's minimum of {{limit}}.",
  step1_limit_hint_range: "This corridor accepts {{min}} to {{max}} per transfer.",
  step1_limit_hint_max: "This corridor accepts up to {{max}} per transfer.",
  step1_limit_hint_min: "This corridor requires at least {{min}} per transfer.",
  step2_limit_blocked:
    "With this method and recipient the amount falls outside the allowed limit ({{limit}}). Adjust the amount to continue.",
  step2_limit_back: "Back to amount",

  step2_client_label: "Client",
  step2_client_loading_placeholder: "Loading clients…",
  step2_client_placeholder: "Select a client…",
  step2_account_label: "Recipient account ({{currency}})",
  step2_account_placeholder: "Select an account…",
  step2_account_fallback_label: "Account",
  step2_no_accounts_note: "This client has no {{currency}} accounts.",
  step2_recipient_section_title: "Who will receive the money",
  step2_recipient_name_label: "Recipient name",
  step2_recipient_name_placeholder: "Full name or business name",
  step2_concept_placeholder: "Supplier payment · invoice 1042",
  step2_separator_brazil: "DESTINATION DETAILS · BRAZIL → PIX",
  step2_separator_mexico: "DESTINATION DETAILS · MEXICO → SPEI",
  step2_separator_argentina: "DESTINATION DETAILS · ARGENTINA → CBU/CVU",
  step2_pix_type_label: "PIX key type",
  step2_clabe_placeholder: "18 digits",
  step2_clabe_error: "The CLABE must have 18 digits.",
  step2_clabe_helper: "18 digits, no spaces or dashes.",
  step2_account_type_cvu: "CVU (wallet)",
  step2_account_type_cbu: "CBU (bank)",
  step2_cbu_cvu_placeholder: "22 digits",
  step2_cbu_cvu_error: "The {{type}} must have 22 digits.",
  step2_cbu_cvu_helper: "22 digits, no spaces or dashes.",
  step2_cuit_label: "Recipient CUIT/CUIL",
  step2_cuit_placeholder: "11 digits, no dashes",
  step2_cuit_error: "The CUIT/CUIL must have 11 digits.",
  step2_cuit_helper: "Optional. Helps the destination bank validate the account holder.",
  // Colombia · TRANSFIYA (ACH en línea)
  step2_col_rail_label: "Delivery method",
  col_rail_breb: "Bre-B key",
  col_rail_transfiya: "Bank account (Transfiya)",
  col_rail_unavailable: "Temporarily unavailable. Try again later.",
  col_rail_not_configured: "Not available for your organization yet.",
  col_rail_balance_low: "Temporarily disabled. Try another method.",
  col_rail_balance_low_try_breb: "Temporarily disabled. Try Bre-B instead.",
  step2_separator_colombia_transfiya: "DESTINATION DETAILS · COLOMBIA → TRANSFIYA",
  step2_tf_bank_label: "Destination bank",
  step2_tf_bank_placeholder: "Select a bank",
  step2_tf_bank_loading: "Loading banks…",
  step2_tf_bank_error: "Could not load the bank list. Reload the page.",
  step2_tf_account_type_label: "Account type",
  tf_account_type_savings: "Savings",
  tf_account_type_checking: "Checking",
  tf_account_type_deposit: "Low-amount deposit",
  tf_account_type_standard_deposit: "Standard deposit",
  tf_account_type_inclusive_deposit: "Inclusive deposit",
  step2_tf_account_number_label: "Account number",
  step2_tf_account_number_placeholder: "Digits only",
  step2_tf_doc_type_label: "Doc. type",
  step2_tf_doc_number_label: "Recipient document",
  step2_tf_doc_number_placeholder: "Digits only",
  error_tf_account_number_invalid: "Enter a valid account number",
  error_tf_bank_required: "Select the destination bank",
  error_tf_doc_number_invalid: "Enter the recipient document",
  step3_tf_bank_label: "Destination bank",
  step3_tf_account_label: "Account",
  step3_tf_doc_label: "Document",
  step2_breb_key_label: "Bre-B key",
  step2_breb_key_helper: "It must be registered as the Bre-B key of whoever receives.",
  step2_breb_key_placeholder_phone: "300 123 4567",
  step2_breb_key_placeholder_email: "email@example.com",
  step2_breb_key_placeholder_alphanum: "@key",
  step2_breb_key_placeholder_nric: "Document number",
  step2_breb_key_placeholder_merchant: "Merchant code",
  step2_breb_key_error_phone: "Enter a valid 10-digit mobile number.",
  step2_breb_key_error_email: "Enter a valid email.",
  step2_breb_key_error_alphanum: "Enter a valid alphanumeric key.",
  step2_breb_key_error_nric: "Enter a valid document.",
  step2_breb_key_error_merchant: "Enter a valid merchant code.",
  breb_key_type_phone: "Mobile",
  breb_key_type_email: "Email",
  breb_key_type_alphanum: "Alphanumeric",
  breb_key_type_nric: "Document",
  breb_key_type_merchant: "Merchant code",
  breb_lookup_loading: "Looking the key up in the Bre-B directory…",
  breb_recipient_idle: "Type the key and we will tell you who holds it",
  breb_recipient_confirmed: "Holder verified at {{bank}}",
  breb_recipient_no_holder: "The key is active, but the directory returned no name",
  breb_recipient_holder_line: "{{holder}} · {{bank}}",
  breb_recipient_saved_as: "Saved in your clients as {{name}}",
  breb_status_unknown: "We could not confirm the status of the key",
  breb_lookup_not_found_detail: "Check the key with whoever is receiving the money.",
  breb_lookup_unavailable_detail:
    "Without confirming who receives, the payment cannot be sent. Try again in a few minutes.",

  breb_lookup_inactive: "The key exists but is not active. The payout would be rejected.",
  breb_lookup_not_found: "This key is not registered with Bre-B",
  breb_lookup_unavailable: "We could not reach the Bre-B directory",
  step3_breb_holder_label: "Verified holder",
  step3_breb_bank_label: "Entity",

  step3_summary_title: "Operation summary",
  step3_recipient_title: "Who receives",
  step3_name_label: "Name",
  step3_clabe_label: "CLABE",
  step3_account_type_label: "Account type",
  step3_cuit_label: "CUIT/CUIL",
  step3_breb_key_type_label: "Key type",
  step3_pix_type_label: "Key type",
  step3_pix_key_label: "PIX key",
  step3_pix_type_email: "Email",
  step3_pix_type_phone: "Phone",
  step3_pix_type_evp: "Random key",
  step3_irreversible_prefix: "Once authorized, the transfer is",
  step3_irreversible_emphasis: "immediate and irreversible",

  send_title: "Send money",
  send_subtitle: "From your {{currency}} wallet",
  send_from_label: "From",
  send_from_wallet: "{{currency}} wallet",
  send_available: "Available {{amount}}",
  send_to_label: "To",
  send_amount_label: "How much are you sending?",
  send_fee_switch: "I'll cover the transfer cost",
  send_fee_on_hint: "They get the full amount; the cost is added to what leaves your wallet.",
  send_fee_off_hint: "The cost comes out of what they receive.",
  send_row_arrives: "They receive",
  send_row_cost: "Transfer cost",
  send_row_debit: "Leaves your wallet",
  send_cost_free: "Free",
  send_insufficient: "Not enough balance: you have {{balance}} available and this transfer needs {{debit}}.",
  send_quote_error: "We couldn't price this transfer. Try again.",
  send_rail_label: "How are you sending it?",
  send_rail_breb_hint: "Arrives in seconds to a key",
  send_rail_transfiya_hint: "To a bank account",
  send_recipient_label: "Who receives it?",
  send_key_label: "Recipient's Bre-B key",
  send_key_placeholder: "Mobile, email, ID number or @key",
  send_key_hint: "Type it as you were given it; we work out which kind of key it is.",
  send_key_type_line: "Key: {{type}}",
  send_tf_name_label: "Account holder's name",
  send_tf_name_placeholder: "As it appears at the bank",
  send_tf_name_error: "Enter the account holder's name",
  send_concept_label: "Concept (optional)",
  send_review: "Review transfer",
  send_cancel: "Cancel",
  send_close: "Close",
  send_read_only:
    "You can see this wallet, but your user can't send money. Ask an administrator in your organization.",
  send_review_title: "Review and confirm",
  send_review_arrives_to: "Goes to",
  send_review_key: "Key",
  send_review_bank: "Bank",
  send_review_account: "Account",
  send_review_document: "ID",
  send_review_via: "Via",
  send_review_concept: "Concept",
  send_review_edit: "Edit",
  send_confirm: "Send {{amount}}",
  send_cost_changed: "The transfer cost changed while you were reviewing. Check the amounts before sending.",
  send_converts_hint: "We convert your {{from}} to {{to}} inside the transfer, at the rate shown below.",
  send_amount_label_arrives: "How much should they receive?",
  send_amount_label_debit: "How much leaves your wallet?",
  send_fee_on_hint_fx:
    "You type what they receive in {{currency}}; the cost and the conversion are added to what leaves.",
  send_fee_off_hint_fx:
    "You type what leaves your wallet in {{currency}}; the cost and the conversion come out of what arrives.",
  send_row_conversion: "Conversion",
  send_rate_label: "Exchange rate",
  send_rate_valid_for: "Price valid for {{time}}",
  send_rail_pix_hint: "Instant, to a PIX key",
  send_rail_spei_hint: "To a CLABE account",
  send_rail_cbu_cvu_hint: "To a CBU or a CVU",
  send_name_label: "Recipient's name",
  send_name_placeholder: "Full name or company name",
  send_pix_key_hint: "Paste it as you were given it; we work out which kind of key it is.",
  send_pix_key_check_error: "Check the number: its check digits don't match.",
  send_clabe_check_error: "Check the CLABE: its check digit doesn't match.",
  send_rfc_label: "RFC",
  send_rfc_placeholder: "12 or 13 characters",
  send_rfc_helper: "Optional. For a company, its 12-character RFC.",
  send_rfc_error: "Check the RFC: 12 characters for a company, 13 for a person.",
  send_review_rfc: "RFC",
  send_transit_from: "Your {{currency}} wallet",
  send_transit_aria: "Sending {{amount}} to {{name}} in {{country}}",
  send_transit_aria_fx: "Sending {{debit}}, converted to {{amount}}, to {{name}} in {{country}}",
  send_processing_fx: "Converting your {{from}} to {{to}} and sending…",
};
